import { Button, useTheme } from "@mui/material";
import AnimateButton from "ui-component/extended/AnimateButton";
import React from "react";

const WhiteButton = (props) => {
  const theme = useTheme();
  return (
    <>
      <AnimateButton>
        <Button
          sx={{
            background: theme.palette.common.white,
            border: "1px solid #2727271A",
            boxShadow: "none",
            ":hover": {
              background: theme.palette.common.white,
              boxShadow: "none",
            },
          }}
          type="button"
          variant="contained"
          {...props}
        >
          {props.title}
        </Button>
      </AnimateButton>
    </>
  );
};

export default WhiteButton;
